<template>
	<div>
		<div class="flex justify-between items-center">
			<h2 class="text-dark-gray mb-6">Market Overview</h2>
			<div>
				<vs-radio v-model="period" vs-value="day" class="mr-5"
					>Last 24 Hours</vs-radio
				>
				<vs-radio v-model="period" vs-value="week">Last 7 Days</vs-radio>
			</div>
		</div>

		<div class="vx-row">
			<div class="vx-col w-full lg:w-1/2 sm:w-1/1 mb-base h-100">
				<h5>
					<span class="text-dark-gray mb-6">Monthly Price Drops</span>
					<a href="" class="ml-5">Show all</a>
				</h5>
				<div class="">
					<vue-apex-charts
						type="line"
						height="250"
						:options="apexChatData.mixedChart.chartOptions"
						:series="apexChatData.mixedChart.series"
					></vue-apex-charts>
				</div>
			</div>
			<div class="vx-col w-full lg:w-1/2 sm:w-1/1 mb-base h-100">
				<h5 class="mb-4">
					<span class="text-dark-gray">Best Deals Today</span>
					<a href="" class="ml-5">Show all</a>
				</h5>
				<div class="vx-row">
					<div class="vx-col w-full lg:w-1/3 sm:w-1/2">
						<vx-card class="h-100">
							<div class="mb-4">
								<h5 class="mb-3 whitespace-nowrap truncate">
									8 Night South Pacific Cruise
								</h5>
								<p class="text-dark-grey">Carnival Splendor</p>
								<p class="text-dark-grey">2021 Mar-17</p>
							</div>
							<div
								class="text-sm border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid mb-4"
							>
								<div class="flex items-center text-sm">
									<feather-icon
										svgClasses="h-4 w-4 stroke-current text-primary"
										icon="PlusCircleIcon"
										class="mr-1"
									/>
									<span>30% price drop</span>
								</div>
								<div class="flex items-center mb-4">
									<feather-icon
										svgClasses="h-4 w-4 stroke-current text-primary"
										icon="PlusCircleIcon"
										class="mr-1"
									/>
									<span>$50 than comp. itins </span>
								</div>
							</div>
							<div class="flex items-center justify-between">
								Interior<br />
								<span
									><span class="text-xl">$499&nbsp;</span>
									<span class="text-primary">-30%</span></span
								>
							</div>
						</vx-card>
					</div>
					<div class="vx-col w-full lg:w-1/3 sm:w-1/2">
						<vx-card class="h-100">
							<div class="mb-4">
								<h5 class="mb-3 whitespace-nowrap truncate">
									8 Night Caribbean Southern Cruise
								</h5>
								<p class="text-dark-grey">Brilliance of the Seas</p>
								<p class="text-dark-grey">2021 May-22</p>
							</div>
							<div
								class="text-sm border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid mb-4"
							>
								<div class="flex items-center text-sm">
									<feather-icon
										svgClasses="h-4 w-4 stroke-current text-primary"
										icon="PlusCircleIcon"
										class="mr-1"
									/>
									<span>25% price drop</span>
								</div>
								<div class="flex items-center mb-4">
									<feather-icon
										svgClasses="h-4 w-4 stroke-current text-primary"
										icon="PlusCircleIcon"
										class="mr-1"
									/>
									<span>$75 than comp. itins </span>
								</div>
							</div>
							<div class="flex items-center justify-between">
								Interior<br />
								<span
									><span class="text-xl">$899&nbsp;</span>
									<span class="text-primary">-25%</span></span
								>
							</div>
						</vx-card>
					</div>
					<div class="vx-col w-full lg:w-1/3 sm:w-1/2">
						<vx-card class="h-100">
							<div class="mb-4">
								<h5 class="mb-3 whitespace-nowrap truncate">
									7 Night Alaskan Explorer Cruise
								</h5>
								<p class="text-dark-grey">Oosterdam</p>
								<p class="text-dark-grey">2021 May-09</p>
							</div>
							<div
								class="text-sm border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid mb-4"
							>
								<div class="flex items-center text-sm">
									<feather-icon
										svgClasses="h-4 w-4 stroke-current text-primary"
										icon="PlusCircleIcon"
										class="mr-1"
									/>
									<span>33% price drop</span>
								</div>
								<div class="flex items-center mb-4">
									<feather-icon
										svgClasses="h-4 w-4 stroke-current text-primary"
										icon="PlusCircleIcon"
										class="mr-1"
									/>
									<span>$60 than comp. itins </span>
								</div>
							</div>
							<div class="flex items-center justify-between">
								Interior<br />
								<span
									><span class="text-xl">$599&nbsp;</span>
									<span class="text-primary">-33%</span></span
								>
							</div>
						</vx-card>
					</div>
				</div>
			</div>
		</div>
		<div class="w-full flex flex-wrap mb-base">
			<div class="w-full flex flex-col lg:w-1/2 sm:w-1/1 pr-4">
				<h5 class="mb-3">
					<span class="text-dark-gray"
						>Cruise Lines Price Drops and Average Discount</span
					>
					<a href="" class="ml-5">Show all</a>
				</h5>
				<div class="vx-row flex-grow">
					<div class="vx-col w-full lg:w-1/4 sm:w-1/2 h-100 text-center">
						<vx-card class="h-100 text-center">
							<router-link
								:to="{
									name: 'search',
									params: {
										filter: { cruiseLine: ['Royal Caribbean Cruises'] },
										sortBy: {
											field: 'priceChangePercent',
											order: -1,
										},
									},
								}"
							>
								<div class="mx-6" style="position: relative">
									<img
										src="/cruise-line-logos/royalcaribbean.svg"
										class="max-w-full"
										style="max-height: 62px"
									/>
									<span
										class="feather-icon-badge bg-primary text-white h-6 w-6 absolute rounded-full text-xs flex items-center justify-center"
										style="top: -7px; right: -5px"
										>37</span
									>
								</div>
							</router-link>
							<h5>avg. -35%</h5>
						</vx-card>
					</div>
					<div class="vx-col w-full lg:w-1/4 sm:w-1/2 h-100 text-center">
						<vx-card class="h-100 text-center">
							<router-link
								:to="{
									name: 'search',
									params: {
										filter: { cruiseLine: ['Princess'] },
										sortBy: {
											field: 'priceChangePercent',
											order: -1,
										},
									},
								}"
							>
								<div class="mx-6" style="position: relative">
									<img
										src="/cruise-line-logos/princess.svg"
										class="max-w-full"
										style="max-height: 62px"
									/>
									<span
										class="feather-icon-badge bg-primary text-white h-6 w-6 absolute rounded-full text-xs flex items-center justify-center"
										style="top: -7px; right: -5px"
										>26</span
									>
								</div>
								<h5>avg. -32%</h5>
							</router-link>
						</vx-card>
					</div>
					<div class="vx-col w-full lg:w-1/4 sm:w-1/2 h-100 text-center">
						<vx-card class="h-100 text-center">
							<router-link
								:to="{
									name: 'search',
									params: {
										filter: { cruiseLine: ['Celebrity'] },
										sortBy: {
											field: 'priceChangePercent',
											order: -1,
										},
									},
								}"
							>
								<div class="mx-6" style="position: relative">
									<img
										src="/cruise-line-logos/celebrity.svg"
										class="max-w-full"
										style="max-height: 62px"
									/>
									<span
										class="feather-icon-badge bg-primary text-white h-6 w-6 absolute rounded-full text-xs flex items-center justify-center"
										style="top: -7px; right: -5px"
										>22</span
									>
								</div>
								<h5>avg. -29%</h5>
							</router-link>
						</vx-card>
					</div>
					<div class="vx-col w-full lg:w-1/4 sm:w-1/2 h-100 text-center">
						<vx-card class="h-100 text-center">
							<router-link
								:to="{
									name: 'search',
									params: {
										filter: { cruiseLine: ['Carnival'] },
										sortBy: {
											field: 'priceChangePercent',
											order: -1,
										},
									},
								}"
							>
								<div class="mx-6" style="position: relative">
									<img
										src="/cruise-line-logos/carnival.svg"
										class="max-w-full"
										style="max-height: 62px"
									/>
									<span
										class="feather-icon-badge bg-primary text-white h-6 w-6 absolute rounded-full text-xs flex items-center justify-center"
										style="top: -7px; right: -5px"
										>15</span
									>
								</div>
								<h5>avg. -28%</h5>
							</router-link>
						</vx-card>
					</div>
				</div>
			</div>
			<div class="w-full flex flex-col lg:w-1/2 sm:w-1/1 pl-4">
				<h5 class="mb-3">
					<span class="text-dark-gray">Price Trends</span>
					<a href="" class="ml-5">Show all</a>
				</h5>
				<div class="vx-row flex-grow">
					<div class="vx-col w-full lg:w-1/2 sm:w-1/1 h-100">
						<!-- <statistics-card-line
              hideChart
              class="h-100 statistics-card-flex"
              icon="ServerIcon"
              icon-right
              statistic="122 cruises"
              statisticTitle="now have the best time to book"
              color="dark" /> -->
						<div class="vx-card h-100">
							<div
								class="p-6 flex justify-between flex-row-reverse items-center"
							>
								<feather-icon
									icon="TrendingDownIcon"
									class="p-3 ml-4 inline-flex rounded-full"
									:class="[`text-dark`]"
									:style="{ background: `rgba(var(--vs-dark),.15)` }"
								></feather-icon>
								<div class="">
									<h2 class="mb-4 font-bold">113 Book Now</h2>
									<div class="grid grid-cols-2">
										<span class="whitespace-no-wrap mr-4">42 Interior</span>
										<span class="whitespace-no-wrap mr-4">14 Oceanview</span>
									</div>
									<div class="grid grid-cols-2">
										<span class="whitespace-no-wrap mr-4">23 Balcony</span>
										<span class="whitespace-no-wrap mr-4">34 Suite</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="vx-col w-full lg:w-1/2 sm:w-1/1 h-100">
						<div class="vx-card h-100">
							<div
								class="p-6 flex justify-between flex-row-reverse items-center"
							>
								<feather-icon
									icon="PercentIcon"
									class="p-3 ml-4 inline-flex rounded-full"
									:class="[`text-dark`]"
									:style="{ background: `rgba(var(--vs-dark),.15)` }"
								></feather-icon>
								<div class="">
									<h2 class="mb-4 font-bold">86 Lowest Price</h2>
									<div class="grid grid-cols-2">
										<span class="whitespace-no-wrap mr-4">22 Interior</span>
										<span class="whitespace-no-wrap mr-4">25 Oceanview</span>
									</div>
									<div class="grid grid-cols-2">
										<span class="whitespace-no-wrap mr-4">14 Balcony</span>
										<span class="whitespace-no-wrap mr-4">25 Suite</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<h5 class="mb-3">
			<span class="text-dark-gray">Open Tasks</span>
			&nbsp;<span
				><router-link
					:to="{
						name: 'task_list',
						params: {},
					}"
					>Show all</router-link
				></span
			>
		</h5>
		<div class="vx-row">

			<div
				class="vx-col w-full lg:w-1/4 sm:w-1/1 h-100"
				v-for="(task, idx) in openTasks.slice(0, 3)"
				:key="idx"
			>
				<router-link
					:to="{
						name: 'task_list',
						params: {},
					}"
				>
					<div class="vx-card h-100 mb-6">
						<div
							class="p-6 flex justify-between flex-row-reverse items-center"
						>
							<feather-icon
								:icon="task.icon"
								class="p-3 ml-4 inline-flex rounded-full text-primary"
								style="background: rgba(var(--vs-primary),.15)"
							></feather-icon>
							<div class="truncate">
								<h2 class="mb-1 font-bold">{{task.short_title ? task.short_title : task.title}}</h2>
								<div class="" v-html="task.short_description ? task.short_description : task.descripton">
								</div>
							</div>
						</div>
					</div>


				</router-link>
			</div>

			<div class="vx-col w-full lg:w-1/4 sm:w-1/1 h-100" v-if="kate">
				<router-link
					@click.native="$bus.$emit('toggle-kate', true)"
					:to="{
						name: 'search',
						params: {
							filter: {
								region: ['Caribbean'],
								cruiseLine: ['Carnival'],
								date: '2021-07-01',
								kkiAlertList: true,
								kkiBudgetAlert: true,
							},
							sortBy: {
								field: 'priceChangePercent',
								order: -1,
							},
						},
					}"
				>
					<statistics-card-line
						hideChart
						class="mb-base"
						icon="BellIcon"
						icon-right
						statistic="Price below budget!"
						statisticTitle="Contact Kate McCartney"
						color="primary"
					/>
				</router-link>
			</div>
			<div class="vx-col w-full lg:w-1/4 sm:w-1/1 h-100" v-else>
				<router-link
					@click.native="$bus.$emit('toggle-kate', true)"
					:to="{
						name: 'search',
						params: {
							filter: {
								region: ['Caribbean'],
								cruiseLine: ['Carnival'],
								date: '2021-07-01',
								kkiAlertList: true,
								kkiPriceAlert: true,
							},
							sortBy: {
								field: 'priceChangePercent',
								order: -1,
							},
						},
					}"
				>
					<statistics-card-line
						hideChart
						class="mb-base"
						icon="BellIcon"
						icon-right
						statistic="Price alert"
						statisticTitle="Contact Kate McCartney"
						color="primary"
					/>
				</router-link>
			</div>
		</div>
		
	</div>
</template>


<script>
import VueApexCharts from "vue-apexcharts";
import apexChatData from "./apexChartData.js";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";

export default {
	data() {
		return {
			apexChatData,
			period: "day",
			kate: false,
		};
	},
	components: {
		VueApexCharts,
		StatisticsCardLine,
	},
	mounted() {
		if (this.$route.params) {
			let kate = this.$route.params.kate;
			if (kate !== null) {
				this.kate = kate;
			}
		}
	},
  computed: {
    openTasks() {
      return window.sampleTaskList.filter((tr) => tr.status != "done");
    }
  }
};
</script>
